import { gql } from '@apollo/client';

const PADDLE_SERVICE_PAYMENT_SALE_ASSET_FIELDS = gql`
  fragment PaddleServicePaymentSaleAssetFields on SaleAsset {
    id
    lotNumber
    soldOrIfPrice
    paddleNumber
    paddlePaymentAmount
    asset {
      id
      stockNumber
    }
    paddleService {
      id
      name
    }
  }
`;

export const PADDLE_SERVICE_PAYMENTS = gql`
  ${PADDLE_SERVICE_PAYMENT_SALE_ASSET_FIELDS}
  query PaddleServicePayments (
    $saleId: ID
  ) {
    paddleServicePayments(
      saleId: $saleId
    ) {
      sale { id }
      sales {
        id
        name
        saleOn
      }
      txns {
        id
        name
        bankDate
        reference
        amount
        type
        txnLines {
          id
          debitLessCredit
          saleAsset {
            ...PaddleServicePaymentSaleAssetFields
          }
        }
      }
      pendingSaleAssets {
        ...PaddleServicePaymentSaleAssetFields
      }
    }
  }
`;

export const CREATE_PADDLE_PAYMENTS = gql`
  mutation CreatePaddlePayments(
    $saleAssetIds: [ID!]!
    $reference: String
    $memo: String
  ) {
    createPaddlePayments(
      saleAssetIds: $saleAssetIds
      reference: $reference
      memo: $memo
    ) {
      txns {
        id
      }
    }
  }
`;

export const CREDIT_PADDLE_PAYMENTS = gql`
  mutation CreditPaddlePayments(
    $txnLineIds: [ID!]!
    $reference: String
    $memo: String
  ) {
    creditPaddlePayments(
      txnLineIds: $txnLineIds
      reference: $reference
      memo: $memo
    ) {
      txns {
        id
      }
    }
  }
`;
